import useSubCatalogueGroupedData from "hook/useSubCatalogueGroupedData";
import { Link, useNavigate } from "react-router-dom";
import { FaCartPlus, FaShoppingCart, FaTag, FaTruck } from "react-icons/fa";
import ShimmerSubCatalogue from "components/shimmer/ShimmerSubCatalogue";
import CardDesign from "components/cardDesign";
import { HiShoppingCart } from "react-icons/hi";
import { TbCurrencyTaka, TbPackageOff } from "react-icons/tb";
import StockOut from "components/stockOut";
import { getCartUpdatedEventName } from "utils/cart";

const SubCatalougeGroupByCatalouge = () => {
  const { subGroupedData, loading } = useSubCatalogueGroupedData();
  const navigate = useNavigate();
  const toCurrency = (amount) => `${(Number(amount) || 0).toLocaleString()} TK`;
  if (loading) {
    return <ShimmerSubCatalogue />;
  }

  const hasData = subGroupedData.some((catalogue) =>
    catalogue.subcatalogues?.some((sub) => sub.items?.length),
  );

  const addToCart = (item) => {
    const existingItems = JSON.parse(localStorage.getItem("babyShop")) || [];

    const key = item.item_id || item.title;
    const existingIndex = existingItems.findIndex(
      (p) => (p.item_id || p.title) === key,
    );

    const firstVariant = item.variants?.[0] || {};

    const colorArray = item.color
      ? item.color.split(",").map((s) => s.trim())
      : [];

    const sizeArray = item.size
      ? item.size.split(",").map((s) => s.trim())
      : [];

    const selectedColor = colorArray[0] || "";
    const selectedSize = sizeArray[0] || "";
    const selectedTitle = firstVariant.title || "";
    const selectedPrice = firstVariant.flashPrice || 0;

    if (existingIndex !== -1) {
      existingItems[existingIndex] = {
        ...existingItems[existingIndex],
        quantity: (existingItems[existingIndex].quantity || 1) + 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
      };
    } else {
      existingItems.push({
        ...item,
        quantity: 1,
        selectedColor,
        selectedSize,
        selectedTitle,
        selectedPrice,
        selectedVariant: firstVariant,
      });
    }

    localStorage.setItem("babyShop", JSON.stringify(existingItems));
    window.dispatchEvent(
      new CustomEvent(getCartUpdatedEventName(), {
        detail: {
          count: existingItems.reduce(
            (sum, item) => sum + (item.quantity || 1),
            0,
          ),
        },
      }),
    );
  };

  return (
    <div className="md:space-y-10 p-4">
      {subGroupedData.length > 0 ? (
        <div className="sm:mb-6 mb-3 flex items-end justify-between gap-3">
          <div>
            <h3 className="mt-2 text-lg font-black text-slate-900 sm:text-3xl">
              Shop by Category & Subcategory
            </h3>
            <p className="text-sm text-slate-600 sm:text-base">
              Handpicked products from each subcategory.
            </p>
          </div>
        </div>
      ) : null}
      {subGroupedData.map((catalogue) => {
        const hasItems = catalogue.subcatalogues?.some((sub) =>
          sub.items?.some((item) => item.hideStatus === "available"),
        );

        return (
          <section
            key={catalogue.catalogue_id}
            className="overflow-hidden rounded-lg border border-slate-100 bg-white shadow-sm my-3"
          >
            <div className="flex flex-wrap items-center justify-between gap-3 bg-gradient-to-r from-slate-900 to-slate-800 px-4 py-4 sm:px-6">
              <div>
                <h4 className="text-lg font-black text-white sm:text-2xl">
                  {catalogue.title}
                </h4>
                <p className="mt-1 text-xs font-medium text-slate-300 sm:text-sm">
                  {catalogue.subcatalogues.length} subcategories available
                </p>
              </div>
              <Link
                type="button"
                to={`/category/${catalogue.catalogue_id}`}
                className="rounded-full bg-white px-4 py-2 text-xs font-bold text-slate-900 transition hover:bg-slate-100 sm:text-sm"
              >
                View All
              </Link>
            </div>
            <div className="space-y-6 p-4 sm:p-6">
              {catalogue.subcatalogues
                .filter((subcategory) =>
                  subcategory.items?.some(
                    (item) => item.hideStatus === "available",
                  ),
                )
                .map((subcategory) => (
                  <div
                    key={subcategory.subCatalogue_id}
                    className="rounded-2xl border border-slate-100 bg-slate-50/70 p-3 sm:p-4"
                  >
                    <div className="mb-3 flex items-center justify-between gap-3">
                      <h5 className="text-sm font-black uppercase tracking-wide text-slate-700 sm:text-base">
                        {subcategory.title}
                      </h5>
                      <Link
                        type="button"
                        to={`/category/${catalogue.catalogue_id}`}
                        className="rounded-full border border-slate-200 bg-white px-3 py-1 text-[11px] font-bold text-slate-700 transition hover:border-slate-300 hover:bg-slate-100 sm:text-xs"
                      >
                        Browse
                      </Link>
                    </div>
                    {/* After properly hosting then pass the data to the cardDesign, below design is not required then */}
                    {/* <CardDesign likeData={subcategory.items} /> */}
                    <div className="container mx-auto px-0 sm:px-6 md:px-10">
                      <div>
                        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 2xl:grid-cols-4 gap-2 sm:gap-4">
                          {subcategory.items?.length ? (
                            subcategory.items
                              .filter((item) => item.hideStatus === "available")
                              .map((item, index) => {
                                const isOutOfStock =
                                  item.status === "unavailable";
                                // ✅ Split title and flashPrice per product
                                const firstVariant = item.variants?.[0] || {};
                                const firstImage =
                                  firstVariant.images?.[0] || "";

                                const selectedTitle = firstVariant.title || "-";
                                const selectedPrice =
                                  firstVariant.flashPrice || 0;
                                const selectedDiscount =
                                  firstVariant.discount || 0;
                                const originalPrice = selectedDiscount || 0;
                                const flashPrice = selectedPrice || 0;

                                const discountPercent =
                                  originalPrice > 0
                                    ? Math.ceil(
                                        ((originalPrice - flashPrice) /
                                          originalPrice) *
                                          100,
                                      )
                                    : 0;
                                return (
                                  <div
                                    key={index}
                                    className={`relative flex flex-col flex-shrink-0 lg:w-[340px] md:w-[240px] max-md:basis-[47%] bg-white rounded-[10px] overflow-hidden transition-transform duration-200 
                                        ${isOutOfStock ? "opacity-40" : ""}
                                    `}
                                  >
                                    {isOutOfStock && <StockOut />}

                                    <a
                                      href={`/details/${item.catalogue}/${item.item_id}`}
                                    >
                                      <div className="relative group aspect-product-desktop w-full overflow-hidden">
                                        <img
                                          src={`https://backend.safiyaenterprise.com/${firstImage}`}
                                          alt={selectedTitle}
                                          className="transition-transform duration-1000 ease-in-out transform w-full group-hover:scale-105  cursor-pointer rounded-t-[10px]"
                                        />
                                        {discountPercent > 0 && (
                                          <span className="absolute left-2 top-2 inline-flex items-center gap-1 rounded-full bg-rose-600 px-2 py-1 text-[10px] font-semibold text-white">
                                            <FaTag className="text-[9px]" />
                                            {discountPercent}% OFF
                                          </span>
                                        )}
                                        {firstVariant.freeVariantDelivery ===
                                          1 && (
                                          <span className="absolute bottom-2 right-2 inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-1 text-[10px] font-medium text-emerald-700">
                                            <FaTruck className="text-[10px]" />
                                            Free Delivery
                                          </span>
                                          // <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-1 text-[10px] font-semibold text-emerald-700 sm:text-xs">
                                          //   <FaTruck className="text-[10px]" />
                                          //   Free Delivery
                                          // </span>
                                        )}
                                      </div>
                                    </a>

                                    <div className="md:px-3 p-2 flex flex-col flex-grow">
                                      <div className="text-black hover:text-[#222836] hover:opacity-60 font-medium tracking-wide mb-1 text-sm whitespace-nowrap overflow-hidden truncate">
                                        {item?.mainTitle}
                                      </div>
                                      <div className="text-black hover:text-[#222836] hover:opacity-60 tracking-wide mb-1 text-xs whitespace-nowrap overflow-hidden truncate">
                                        {selectedTitle}
                                      </div>
                                      <div className="flex pb-2">
                                        <div className="relative inline-flex items-center text-gray-400 text-sm mr-2">
                                          <span className="flex items-center">
                                            <p>{selectedDiscount}</p>
                                            <TbCurrencyTaka className="font-semibold" />
                                          </span>
                                          <div className="absolute left-0 right-0 top-1/2 h-[1px] bg-gray-400"></div>
                                        </div>
                                        <div className="flex text-[#265fc9] items-center text-sm">
                                          <p className="font-bold">
                                            {selectedPrice}
                                          </p>
                                          <TbCurrencyTaka className="font-semibold" />
                                        </div>
                                      </div>

                                      {!isOutOfStock && (
                                        <div className="flex gap-2 my-1 mt-auto">
                                          <button
                                            lang="bn"
                                            onClick={(e) => {
                                              addToCart(item);
                                              navigate("/orderDetails");
                                            }}
                                            className="md:text-base text-sm flex-1 text-white bg-backgroundColor border border-darkBgColor rounded-md md:px-4 px-2 py-1 md:font-bold font-semibold flex justify-center items-center"
                                          >
                                            অর্ডার করুন
                                          </button>
                                          <button
                                            type="button"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              addToCart(item);
                                            }}
                                            className="md:px-3 px-2 rounded-md border text-darkBgColor py-1"
                                          >
                                            <span className="group-hover:hidden md:text-base text-sm">
                                              <FaCartPlus />
                                            </span>
                                            <HiShoppingCart className="hidden group-hover:block w-5 h-5" />
                                          </button>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                );
                              })
                          ) : (
                            <div className="flex flex-1 flex-col justify-center items-center text-center text-[#265fc9] py-10">
                              <TbPackageOff className="mx-auto w-40 h-40 mb-5 text-backgroundColor animate-pulse" />
                              <h3 className="text-base sm:text-lg font-semibold mb-2 mt-5">
                                কোনো পণ্য পাওয়া যায়নি
                              </h3>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    {/* <div className="grid grid-cols-1 gap-3 md:grid-cols-2">
                      {subcategory.items
                        .filter((item) => item.hideStatus === "available")
                        .map((item, index) => {
                          console.log("Catalogue:", catalogue.title);
                          console.log(
                            "Subcategories:",
                            catalogue.subcatalogues.length,
                          );
                          const isOutOfStock = item.status === "unavailable";
                          const firstVariant = item.variants?.[0] || {};
                          const firstImage = firstVariant.images?.[0] || "";
                          const selectedTitle = firstVariant.title || "-";
                          const selectedPrice = firstVariant.flashPrice || 0;
                          const selectedDiscount = firstVariant.discount || 0;
                          const originalPrice = selectedDiscount || 0;
                          const flashPrice = selectedPrice || 0;
                          const discountPercent =
                            originalPrice > 0
                              ? Math.ceil(
                                  ((originalPrice - flashPrice) /
                                    originalPrice) *
                                    100,
                                )
                              : 0;

                          return (
                            <article
                              key={`${item.item_id}-${index}`}
                              className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
                            >
                              <div className="flex flex-col sm:flex-row">
                                <img
                                  src={`https://backend.safiyaenterprise.com/${firstImage}`}
                                  alt={selectedTitle}
                                  className="h-44 w-full shrink-0 cursor-pointer object-cover sm:h-36 sm:w-36"
                                />
                                <div className="flex-1 p-3">
                                  <div className="flex items-start justify-between gap-2">
                                    <h6 className="line-clamp-2 cursor-pointer text-sm font-semibold text-slate-800 sm:text-base">
                                      {selectedTitle}
                                    </h6>
                                    {discountPercent > 0 && (
                                      <span className="inline-flex items-center gap-1 rounded-full bg-rose-600 px-2 py-1 text-[10px] font-semibold text-white">
                                        <FaTag className="text-[9px]" />
                                        {discountPercent}%
                                      </span>
                                    )}
                                  </div>

                                  <div className="mt-2 flex items-end gap-2">
                                    <p className="text-base font-black text-slate-900">
                                      {toCurrency(selectedPrice)}
                                    </p>
                                    <p className="text-xs font-medium text-slate-500 line-through">
                                      {toCurrency(selectedDiscount)}
                                    </p>
                                  </div>

                                  <div className="mt-2 flex items-center justify-between">
                                    {firstVariant.freeVariantDelivery === 1 ? (
                                      <span className="inline-flex items-center gap-1 rounded-full bg-emerald-100 px-2 py-1 text-[10px] font-semibold text-emerald-700 sm:text-xs">
                                        <FaTruck className="text-[10px]" />
                                        Free Delivery
                                      </span>
                                    ) : (
                                      <span className="text-[10px] text-slate-500 sm:text-xs"></span>
                                    )}
                                  </div>

                                  <div className="mt-3 flex items-center gap-2">
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        addToCart(item);
                                        navigate("/orderDetails");
                                      }}
                                      className="flex-1 rounded-lg bg-blue-600 px-3 py-2 text-xs font-bold text-white transition hover:bg-blue-700 sm:text-sm"
                                    >
                                      Order Now
                                    </button>
                                    <button
                                      type="button"
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        addToCart(item);
                                      }}
                                      aria-label={`Add ${selectedTitle} to cart`}
                                      className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-slate-200 bg-white text-slate-700 transition hover:bg-slate-100"
                                    >
                                      <FaShoppingCart />
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </article>
                          );
                        })}
                    </div> */}
                  </div>
                ))}
            </div>
          </section>
        );
      })}
    </div>
  );
};

export default SubCatalougeGroupByCatalouge;
